<template>
  <div id="OpenAccountApply">
    <div
      class="loadingBox"
      v-if="loadingBox"
    >
      <Loading
        type="spinner"
        color="#fff"
        accountFont="正在开户中，请勿离开…"
      >
      </Loading>
    </div>
    <van-cell-group class="mt8 forms">
      <Input
        class="temr"
        placeholder="请输入身份证号"
        v-model="borrowerIdentity"
        labelWidth="110px"
        :readonly="true"
        :reg="rules.borrowerIdentity"
        label="身份证号"
      />
      <Input
        class="temr"
        placeholder="请输入姓名"
        v-model="borrowerName"
        :readonly="true"
        labelWidth="110px"
        :reg="rules.borrowerName"
        label="姓名"
      />
      <div style="position: relative;">
        <Input
          class="temr"
          placeholder="请输入 I 类银行卡号"
          v-model="bankNumber"
          maxlength="30"
          labelWidth="110px"
          type="tel"
          :reg="rules.bankNumber"
          label="银行卡号"
        />
        <div
          class="support"
          @click="supportIsShow"
        >支持银行</div>
      </div>
      <Input
        class="temr"
        placeholder="请输入银行预留手机号"
        v-model="legalPhone"
        maxlength="11"
        labelWidth="110px"
        border
        type="tel"
        :reg="rules.legalPhone"
        label="手机号"
      />
      <MessageCode
        model="captcha"
        IsInterface="true"
        maxlength="6"
        type="number"
        placeholder="请输入验证码"
        :reg="rules.captcha"
        label="验证码"
      />
      <div class="line">
      </div>
      <BWSelect
        placeholder="请选择职业"
        label="职业"
        model="occupation"
        :columnsTerm="columnsTermMethod"
      />
      <!-- <BWSelect
        v-if="tempSecondData[this.$store.state.commonForms.occupation]"
        placeholder="请选择职业细类"
        label="职业细类"
        model="occupationSmall"
        :columnsTerm="tempSecondData[this.$store.state.commonForms.occupation]"
      /> -->
      <OpenAccountContract v-model="agreeState" :optionalFlag.sync="optionalFlag"></OpenAccountContract>
      <Button
        :text="draw"
        :type="danger"
        :disabled="canGoNext"
        class="nextStep"
        :click="getDialog"
      />
    </van-cell-group>
    <div class="giveUp">
      <span @click="giveUp">放弃开通Ⅱ类电子账户{{optionalFlag}}</span>
    </div>
    <self-popup
      Isclose
      @define="giveUpReturn"
      v-model="ShowGiveUpContent"
    ></self-popup>
    <self-popup v-model="ShowPopupContent"></self-popup>
    <BankSupport
      :showBankProps="showBankProps"
      :banklist="banklist"
      @setShowBank="setShowBank"
    >
    </BankSupport>
  </div>
</template>
<script>
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Loading from '@/components/Loading.vue';
import { Toast, Dialog } from 'vant';
import { mapGetters, mapMutations } from 'vuex';
import { rules } from '@/utils';
import BankSupport from './components/BankSupport.vue';
import OpenAccountContract from './components/OpenAccountContract.vue';
import MessageCode from '../commonPage/components/MessageCode.vue';
import BWSelect from '../commonPage/components/BWSelect.vue';

export default {
  name: 'OpenAccountApply',
  data() {
    return {
      optionalFlag: '', // 可选协议 0-签约 1-不签约 默认为1
      danger: 'danger',
      draw: '提交',
      agreeState: false,
      banklist: [],
      ShowPopupContent: '',
      ShowGiveUpContent: '',
      loadingBox: false,
      columnsTermMethod: [],
      timerInteval: '',
      IsShowReturnPopup: false,
      applyNo: '',
      showBankProps: false,
      bankNumber: '',
      legalPhone: '',
      borrowerIdentity: '',
      borrowerName: '',
      rules,
      // 前端临时固定值，3月15号版本改为动态
      tempOccupationList: {"success":true,"returnCode":"200","returnMessage":"操作成功","data":[{"id":null,"occupationCode":"40100","occupationName":"批发与零售服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"68100","occupationName":"基础制造业（食品、化工、采矿、冶金等）","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"68200","occupationName":"高级制造业（大型设备、精密仪器、专用设备、精密化工、制药等）","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"40200","occupationName":"交通运输、仓储和邮政业服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"40300","occupationName":"住宿和餐饮服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"40700","occupationName":"租赁和商务服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"41000","occupationName":"居民服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"41200","occupationName":"修理及制作服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"41400","occupationName":"健康服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"49900","occupationName":"其他社会生产和生活服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"50100","occupationName":"农业生产人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"50200","occupationName":"林业生产人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"50300","occupationName":"畜牧业生产人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"50400","occupationName":"渔业生产人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"50500","occupationName":"农林牧渔生产辅助人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"59900","occupationName":"其他农、林、牧、渔、水利业生产人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"20200","occupationName":"工程技术人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"20300","occupationName":"农业技术人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"20400","occupationName":"飞机和船舶技术人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"20500","occupationName":"卫生专业技术人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"40400","occupationName":"信息运输、软件和信息技术服务人员","productId":null,"status":null,"createTime":null,"updateTime":null},{"id":null,"occupationCode":"41300","occupationName":"文化、体育及娱乐服务人员","productId":null,"status":null,"createTime":null,"updateTime":null}]},
    };
  },
  components: {
    Button,
    BWSelect,
    Input,
    MessageCode,
    Loading,
    BankSupport,
    OpenAccountContract
  },
  mounted() {
    this.updateForm({
      occupation: '',
      occupationText: '',
    });
    const {
      getbanklist,
      getInformation,
    } = this.$api.CommonForms;
    const { orderId } = this.$router.currentRoute.query;
    getbanklist().then((res) => {
      if (res.success) {
        this.banklist = res.data;
      } else {
        Toast(res.returnMessage);
      }
    });
    this.columnsTermMethod = this.tempOccupationList.data.map((item) => ({
      text: item.occupationName,
      value: item.occupationCode,
    }));
    getInformation(orderId).then((res) => {
      if (res && res.success) {
        const { borrowerIdentity, borrowerName } = res.data;
        this.borrowerIdentity = borrowerIdentity;
        this.borrowerName = borrowerName;
      } else {
        Toast(res.returnMessage);
      }
    });
  },
  computed: {
    ...mapGetters(["occupation"]),
    occupationWatch() {
      return this.$store.state.commonForms.occupation;
    },
    canGoNext() {
      const temrData = ['captcha', 'occupation'];
      let multiCheck = false;
      temrData.forEach((item) => {
        console.log(this.$store.state.commonForms[item]);
        if (this.$store.state.commonForms[item] === '') {
          multiCheck = true;
        }
      });
      const regOne = /^1\d{10}$/;
      const regtwo = /^\d{8,30}$/;
      const regthree = /^\d{6}$/;
      if (
        !regOne.test(this.legalPhone)
        || !regtwo.test(this.bankNumber)
        || !regthree.test(this.$store.state.commonForms.captcha)
      ) {
        multiCheck = true;
      }
      if (!this.agreeState) {
        multiCheck = true;
      }
      return multiCheck;
    },
  },
  watch: {
    legalPhone: {
      handler(newVal) {
        this.updateForm({
          legalPhone: newVal,
        });
      },
      immediate: true,
    },
    occupationWatch: {
      // 大类改变 重置小类
      handler(newVal) {
        this.updateForm({
          occupationSmall: '',
          occupationSmallText: '',
        });
      },
      immediate: true,
    }
  },
  methods: {
    ...mapMutations('commonForms', ['updateForm']),
    giveUp() {
      this.ShowGiveUpContent = '确定放弃开通Ⅱ类电子账户？';
    },
    supportIsShow() {
      this.showBankProps = true;
    },
    giveUpReturn(obj) {
      this.$router.push('/supermarket/v2/fillCardNumber');
      // eslint-disable-next-line no-unused-expressions
      obj.cb && obj.cb();
    },
    getDialog() {
      Dialog.confirm({
        title: '提示',
        message: '本人充分了解并清楚知晓出租、出借、出售、购买账户的相关法律责任和惩戒措施，承诺依法依规开立和使用本人账户',
      })
        .then(() => {
          this.goToNextPage()
        })
        .catch(() => {
          Dialog.close()
        });
    },
    goToNextPage() {
      this.loadingBox = true;
      const { captcha, occupation, occupationSmall } = this.$store.state.commonForms;
      this.$api.CommonForms.openBankInfo({
        orderId: this.$router.currentRoute.query.orderId,
        card_num: this.bankNumber,
        cust_mobile: this.legalPhone,
        random_password: captcha,
        occupation_code: occupation,
        infoServiceSign: this.optionalFlag ? 0 : 1,
      }).then((res) => {
        if (res.success) {
          this.applyNo = res.data.apply_no;
          this.getOpenBankState();
        } else {
          this.loadingBox = false;
          this.ShowPopupContent = res.returnMessage;
        }
      });
    },
    getOpenBankState() {
      this.$api.CommonForms.getOpenBankState({
        apply_no: this.applyNo,
        orderId: this.$router.currentRoute.query.orderId,
      }).then((res) => {
        if (!res.success) {
          this.timerInteval = setTimeout(this.getOpenBankState, 4000);
        } else if (res.success && res.data.ret_code === '0') {
          clearTimeout(this.timerInteval);
          this.$router.push(
            `/supermarket/v2/OpenAccountSuccess?applyNo=${this.applyNo}&orderId=${this.$router.currentRoute.query.orderId}`,
          );
        } else if (res.success && res.data.ret_code === '2') {
          this.loadingBox = false;
          clearTimeout(this.timerInteval);
          this.ShowPopupContent = res.data.ret_msg;
        } else {
          this.timerInteval = setTimeout(this.getOpenBankState, 4000);
        }
      });
    },
    setShowBank() {
      this.showBankProps = false;
    },
  },
};
</script>
<style scoped>
#OpenAccountApply {
  width: 100%;
  height: 100%;
  background: #fff;
}
.partition {
  width: 100%;
  height: 15px;
  background: #f8f8f9;
}
.OpenAccountApplyHead {
  width: 100%;
  height: 45px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.leftRight {
  width: 82px;
  height: 23px;
  border: rgba(230, 230, 230, 1) solid 1px;
  font-size: 13px;
  line-height: 23px;
  padding-left: 15px;
  color: rgba(255, 87, 51, 1);
}
.giveUp {
  text-align: center;
  margin-top: 49px;
  font-size: 14px;
  color: #0079cc;
}
>>> .van-field__label {
  width: 110px;
}
.temr::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.mt8 {
  padding-top: 8px;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.getCode {
  color: rgba(246, 82, 73, 1);
  font-weight: 400;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.code_btn {
  position: absolute;
  right: 14px;
  bottom: 7px;
  z-index: 3;
  width: auto;
  height: 35px;
  background: #fff;
  border: none;
}
.loadingBox {
  position: fixed;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.45);
}
.banklistBox {
  width: 100%;
  display: flex;
  justify-content: left;
  flex-flow: row wrap;
  flex: 1;
  overflow: scroll;
  height: 90%;
}
.banklistLi {
  width: 50%;
  height: 45px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close {
  width: 100%;
  height: 40px;
  line-height: 40px;
  position: relative;
  border-bottom: 1px solid #e9f0f5;
  font-family: PingFangSC-Regular;
  font-size: 17px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
}
.support {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 14px;
  color: #f65846;
  background: #fff;
}
.line {
  height: 0.5px;
  background: #ebecef;
  margin: 0 16px;
}
>>>.van-field__control::placeholder {
        color: #767676 !important;
    }
>>>.van-field__label{
  color: #1c2438;
}
>>>.van-field__control{
  margin-left: -11px;
}
</style>
